<template>
    <div class="abstract-list">
        <a-row :gutter="[10, 10]">
            <!-- <a-col :xl="4" :lg="4" :xs="6" style="text-align: left;">
                <a-input v-model="searchParams.reg_no" type="text" placeholder="注册号"></a-input>
            </a-col> -->
            <a-col :xl="4" :lg="4" :xs="12" style="text-align: left">
                <a-input v-model="searchParams.number" type="text" :placeholder="$t('submission.abstract_list.search_paper_id' /* 论文ID */)"></a-input>
            </a-col>
            <a-col :xl="4" :lg="4" :xs="12" style="text-align: left">
                <a-input v-model="searchParams.title" type="text" :placeholder="$t('submission.abstract_list.search_title' /* 题目 */)"></a-input>
            </a-col>
            <a-col :xl="4" :lg="4" :xs="12" style="text-align: left">
                <a-input v-model="searchParams.real_name" type="text" :placeholder="$t('submission.abstract_list.search_first_author' /* 第一作者 */)"></a-input>
            </a-col>
            <a-col :xl="4" :lg="4" :xs="12" style="text-align: left">
                <a-input v-model="searchParams.org_cnname" type="text" :placeholder="$t('submission.abstract_list.search_first_author_org' /* 第一作者单位 */)"></a-input>
            </a-col>
            <a-col :xl="4" :lg="4" :xs="12" style="text-align: left">
                <a-select v-model="searchParams.first_author_province" :placeholder="$t('submission.abstract_list.search_first_author_province' /* 第一作者省份 */)" style="width: 100%">
                    <a-select-option :value="0">{{ $t('submission.abstract_list.search_first_author_province' /* 第一作者省份 */) }}</a-select-option>
                    <a-select-option v-for="(item, index) in provinceList" :key="index" :value="Number(item.id)">{{ item.name }}</a-select-option>
                </a-select>
            </a-col>
            <a-col :xl="4" :lg="4" :xs="12" style="text-align: left">
                <a-input v-model="searchParams.t_real_name" type="text" :placeholder="$t('submission.abstract_list.search_submitter' /* 投稿作者 */)"></a-input>
            </a-col>
            <a-col :xl="4" :lg="4" :xs="12" style="text-align: left">
                <a-select v-model="searchParams.is_reg_fee" :placeholder="$t('submission.abstract_list.search_payment_status' /* 注册支付状态 */)" style="width: 100%">
                    <a-select-option :value="0">{{ $t('submission.abstract_list.search_payment_status_placeholder' /* 请选择支付状态 */) }}</a-select-option>
                    <a-select-option :value="1">{{ $t('submission.abstract_list.search_payment_status_paid' /* 已支付 */) }}</a-select-option>
                    <a-select-option :value="-1">{{ $t('submission.abstract_list.search_payment_status_unpaid' /* 未支付 */) }}</a-select-option>
                </a-select>
            </a-col>
            <a-col :xl="4" :lg="4" :xs="12" style="text-align: left">
                <a-select v-model="searchParams.is_finish" :placeholder="$t('submission.abstract_list.search_manuscript_status' /* 稿件状态 */)" style="width: 100%">
                    <a-select-option :value="0">{{ $t('submission.abstract_list.search_manuscript_status_placeholder' /* 请选择稿件状态 */) }}</a-select-option>
                    <a-select-option v-for="(item, index) in abstractStatusList" :key="index" :value="item.value">{{ item.label }}</a-select-option>
                </a-select>
            </a-col>
            <!-- <a-col :xl="4" :lg="4" :xs="6" style="text-align: left;">
                <a-select v-model="searchParams.is_finalization" placeholder="审核状态" style="width:100%;">
                    <a-select-option :value="0">
                        请选择审核状态
                    </a-select-option>
                    <a-select-option :value="-1">
                        未审核
                    </a-select-option>
                    <a-select-option :value="1">
                        已审核
                    </a-select-option>
                    <a-select-option :value="2">
                        已驳回
                    </a-select-option>
                </a-select>
            </a-col> -->

            <a-col :xl="4" :lg="4" :xs="12" style="text-align: left">
                <a-select v-model="searchParams.channel_id" :placeholder="$t('submission.abstract_list.search_channel' /* 论文渠道 */)" style="width: 100%">
                    <a-select-option :value="0">{{ $t('submission.abstract_list.search_channel_placeholder' /* 请选择论文渠道 */) }}</a-select-option>
                    <a-select-option v-for="(item, index) in channelList" :key="index" :value="item.channel_id">{{ item.title }}</a-select-option>
                </a-select>
            </a-col>

            <a-col :xl="4" :lg="4" :xs="12" style="text-align: left">
                <a-tree-select
                    :tree-default-expand-all="true"
                    style="width: 100%"
                    :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                    :tree-data="classList"
                    :placeholder="$t('submission.abstract_list.search_class' /* 论文类别 */)"
                    v-model="searchParams.class_id"
                />
            </a-col>

            <a-col :xl="4" :lg="4" :xs="12" style="text-align: left">
                <a-select v-model="searchParams.review_results" :placeholder="$t('submission.abstract_list.search_acceptance_type' /* 录用类型 */)" style="width: 100%">
                    <a-select-option :value="0">{{ $t('submission.abstract_list.search_acceptance_type_placeholder' /* 请选择录用类型 */) }}</a-select-option>
                    <a-select-option v-for="(item, index) in hireList" :key="index" :value="item.id">{{ item.typename_cn }}</a-select-option>
                </a-select>
            </a-col>

            <a-col :xl="4" :lg="4" :xs="12" style="text-align: left">
                <a-select v-model="searchParams.abstract_sort" :placeholder="$t('submission.abstract_list.search_sort' /* 排序 */)" style="width: 100%">
                    <a-select-option :value="0">{{ $t('submission.abstract_list.search_sort_placeholder' /* 请选择排序 */) }}</a-select-option>
                    <a-select-option :value="-1">{{ $t('submission.abstract_list.search_sort_desc' /* 按论文ID降序排序 */) }}</a-select-option>
                    <a-select-option :value="1">{{ $t('submission.abstract_list.search_sort_asc' /* 按论文ID升序排序 */) }}</a-select-option>
                    <a-select-option :value="4">{{ $t('submission.abstract_list.search_sort_update_time' /* 按最后更新时间排序 */) }}</a-select-option>
                </a-select>
            </a-col>

            <a-col :xl="4" :lg="4" :xs="12" style="text-align: left">
                <a-select v-model="searchParams.publish_type" :placeholder="$t('submission.abstract_list.search_publish_type' /* 拟交流类型 */)" style="width: 100%">
                    <a-select-option value="">{{ $t('submission.abstract_list.search_publish_type_placeholder' /* 请选择拟交流类型 */) }}</a-select-option>
                    <a-select-option v-for="(item, index) in publishTypeObj" :value="item" :key="index">{{ item }}</a-select-option>
                </a-select>
            </a-col>

            <!-- <a-col :xl="4" :lg="4" :xs="6" style="text-align: left;">
                <a-select v-model="searchParams.acceptance_state" placeholder="是否接受" style="width:100%;">
                    <a-select-option :value="0">
                        是否接受
                    </a-select-option>
                    <a-select-option :value="-1">
                        未确认
                    </a-select-option>
                    <a-select-option :value="1">
                        接受
                    </a-select-option>
                    <a-select-option :value="2">
                        拒绝
                    </a-select-option>
                </a-select>
            </a-col> -->
            <a-col :xl="8" :lg="8" :xs="24" style="text-align: left">
                <a-button type="primary" @click="resetList">{{ $t('submission.abstract_list.button_search' /* 搜索 */) }}</a-button>
                <a-button class="ml10" type="primary" icon="plus" @click="handleEditEvent">{{ $t('submission.abstract_list.button_add' /* 添加 */) }}</a-button>
                <a-button class="ml10" type="default" @click="handleClearSearchValueEvent">{{ $t('submission.abstract_list.button_clear' /* 清空 */) }}</a-button>
            </a-col>
        </a-row>
        <div class="flex x-left mt20 button-list" style="width: 100%">
            <!-- 录取通知函 邮件 -->
            <div class="mr30">
                <a-button type="primary" @click="$refs.editEmailRef.show(8, 1, $t('submission.abstract_list.button_set_cn_notice' /* 设置中文录取通知函 */))">
                    {{ $t('submission.abstract_list.button_set_cn_notice' /* 设置中文录取通知函 */) }}
                </a-button>
                <a-button class="ml5" type="primary" @click="$refs.editEmailRef.show(8, 2, $t('submission.abstract_list.button_set_en_notice' /* 设置英文录取通知函 */))">
                    {{ $t('submission.abstract_list.button_set_en_notice' /* 设置英文录取通知函 */) }}
                </a-button>
            </div>
            <!-- 审核短信 -->
            <!-- <div>
                <a-button class="ml5" type="primary" @click="$refs.editMsmRef.show(25, '设置审核通过短信')">设置审核通过短信</a-button>
                <a-button class="ml5" type="primary" @click="$refs.editMsmRef.show(26, '设置审核驳回短信')">设置审核驳回短信</a-button>
            </div> -->
            <!-- 审核邮件 -->
            <!-- <div class="ml5">
                <a-button type="primary" @click="$refs.editEmailRef.show(19, 1, '设置审核通过邮件')">设置审核通过邮件</a-button>
                <a-button class="ml5" type="primary" @click="$refs.editEmailRef.show(20, 1, '设置审核驳回邮件')">设置审核驳回邮件</a-button>
            </div> -->
            <a-button type="primary" @click="$refs.editHistoryRef.show()" class="ml30">{{ $t('submission.abstract_list.button_email_record' /* 发送邮件记录 */) }}</a-button>
        </div>
        <s-table
            class="mt20"
            ref="table"
            :rowKey="record => record.id"
            size="middle"
            :columns="columns"
            :data="loadData"
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: handleSelectChange }"
            :scroll="{ x: 2100, y: 'calc(100vh - 500px)' }"
        >
            <!-- 附件 -->
            <span slot="attachment" slot-scope="text, record">
                <a-button type="link" @click="$refs.uploadRef.show(record, 'full_text_cn')">{{ $t('submission.abstract_list.table_upload_cn_attachment' /* 上传中文附件 */) }}</a-button>
                <a-button type="link" @click="$refs.uploadRef.show(record, 'full_text_en')" class="mt5">{{ $t('submission.abstract_list.table_upload_en_attachment' /* 上传英文附件 */) }}</a-button>
            </span>
            <!-- ppt -->
            <span slot="updatePPT" slot-scope="text, record">
                <a-button type="link" @click="$refs.uploadRef.show(record, 'ppt_cn')">{{ $t('submission.abstract_list.table_upload_cn_ppt' /* 上传中文PPT */) }}</a-button>
                <a-button type="link" class="mt5" @click="$refs.uploadRef.show(record, 'ppt_en')">{{ $t('submission.abstract_list.table_upload_en_ppt' /* 上传英文PPT */) }}</a-button>
            </span>
            <!-- 电子壁报 -->
            <span slot="poster" slot-scope="text, record">
                <a-button type="link" @click="$refs.uploadRef.show(record, 'poster_ppt_cn')">{{ $t('submission.abstract_list.table_upload_cn_poster' /* 上传中文壁报 */) }}</a-button>
                <a-button type="link" @click="$refs.uploadRef.show(record, 'poster_ppt_en')" class="mt5">{{ $t('submission.abstract_list.table_upload_en_poster' /* 上传英文壁报 */) }}</a-button>
            </span>
            <!-- 审核状态 -->
            <!-- <span slot="is_finalization" slot-scope="text,record">
                <template v-if="isAuditFun(record)">
                    <a-badge v-if="text == 0" :status="'warning'" text="未审核"/>
                    <a-badge v-if="text == 1" status="success" text="已审核"/>
                    <a-badge v-if="text == 2" status="error" text="已驳回"/>
                </template>
                <template v-else>
                    <a-badge status="success" text="无需审核确认"></a-badge>
                </template>
            </span> -->
            <!-- 录用类型 -->
            <span slot="review_results_name" slot-scope="text">
                {{ text ? text : '无最终录用类型' }}
            </span>
            <!-- 论文录取通知函 -->
            <span slot="notice" slot-scope="text, record">
                <span class="pointer" @click="$refs.emailViewRef.show(record.id)">
                    <a-tooltip>
                        <template slot="title">{{ $t('submission.abstract_list.table_preview_email' /* 点击预览邮件 */) }}</template>
                        <a-button type="primary" size="small"><i class="medcon med-yulan"></i></a-button>
                    </a-tooltip>
                </span>
                <span class="pointer ml5">
                    <a-tooltip>
                        <template slot="title">{{ $t('submission.abstract_list.table_send_email' /* 点击发送邮件 */) }}</template>
                        <a-button type="primary" size="small"><i class="medcon med-fasongyoujian"></i></a-button>
                    </a-tooltip>
                </span>
                <a-button class="ml5" type="default" size="small">0次</a-button>
            </span>
            <!-- 提交者 -->
            <span slot="sys_user_name" slot-scope="text, record">
                <span v-html="text"></span>
            </span>
            <!-- 备注 -->
            <!-- <span slot="remark">
                <a-textarea></a-textarea>
            </span> -->
            <!--    操作   -->
            <span slot="action" slot-scope="text, record">
                <a-button type="link" @click="handleEditEvent(record)">{{ $t('submission.abstract_list.table_edit' /* 编辑 */) }}</a-button>
                <a-button type="link" @click="handleDeleteEvent(record)" class="del-button">{{ $t('submission.abstract_list.table_delete' /* 删除 */) }}</a-button>
                <!-- <a-button type="link" v-if="isAuditFun(record)" @click="$refs.abstractAuditRef.show(record.id)">审核</a-button> -->
                <a-button type="link" @click="$refs.abstractDetailRef.show(record.id)">{{ $t('submission.abstract_list.table_preview' /* 预览 */) }}</a-button>
                <!-- <a-button type="link">上传视频</a-button> -->
                <a-button type="link" @click="handleDownloadAnnexEvent(record.annex_list)">{{ $t('submission.abstract_list.table_download_attachment' /* 下载附件 */) }}</a-button>
            </span>
        </s-table>
        <!-- 论文编辑 -->
        <abstract-edit ref="abstractEditRef" @reset="resetList"></abstract-edit>
        <!-- 论文详情 -->
        <abstract-detail ref="abstractDetailRef"></abstract-detail>
        <!-- 审核 -->
        <abstract-audit ref="abstractAuditRef"></abstract-audit>
        <!-- 文件上传 -->
        <upload ref="uploadRef"></upload>
        <!-- 邮箱模板编辑 -->
        <edit-email ref="editEmailRef"></edit-email>
        <!-- 短信模板 -->
        <edit-sms ref="editMsmRef"></edit-sms>
        <!-- 发送邮件记录 -->
        <email-history ref="editHistoryRef"></email-history>
        <!-- 预览邮件 -->
        <email-view ref="emailViewRef"></email-view>
    </div>
</template>

<script>
import STable from '@/components/Table';
import moment from 'moment';
import abstractEdit from './components/abstract-edit.vue';
import abstractDetail from './components/abstract-detail.vue';
import abstractAudit from './components/abstract-audit.vue';
import { abstractStatusList } from '@/config/const';
import editEmail from './components/edit-email.vue';
import upload from './components/upload.vue';
import editSms from './components/edit-sms.vue';
import emailHistory from './components/email-history.vue';
import emailView from './components/email-view.vue';
export default {
    name: 'AbstractList',
    components: {
        STable,
        abstractEdit,
        abstractDetail,
        abstractAudit,
        upload,
        editEmail,
        editSms,
        emailHistory,
        emailView
    },
    data() {
        return {
            abstractStatusList,
            columns: [
                {
                    title: this.$t('submission.abstract_list.table_paper_id' /* 论文ID */),
                    dataIndex: 'number',
                    align: 'center',
                    width: 80
                },
                {
                    title: this.$t('submission.abstract_list.table_class' /* 分类 */),
                    dataIndex: 'class_title',
                    width: 150,
                    align: 'center'
                },
                {
                    title: this.$t('submission.abstract_list.table_title' /* 题目 */),
                    dataIndex: 'title',
                    width: 180,
                    align: 'center'
                },
                {
                    title: this.$t('submission.abstract_list.table_first_author' /* 第一作者 */),
                    dataIndex: 'real_name',
                    width: 120,
                    align: 'center'
                },
                {
                    title: this.$t('submission.abstract_list.table_submitter' /* 提交者 */),
                    dataIndex: 'sys_user_name',
                    scopedSlots: { customRender: 'sys_user_name' },
                    align: 'center',
                    width: 120
                },
                // {
                //     title: '审核状态',
                //     dataIndex: 'is_finalization',
                //     scopedSlots: { customRender: 'is_finalization' },
                //     align: 'center',
                //     width: 120,
                // },
                {
                    title: this.$t('submission.abstract_list.table_acceptance_type' /* 录用类型 */),
                    dataIndex: 'review_results_name',
                    scopedSlots: { customRender: 'review_results_name' },
                    align: 'center',
                    width: 100
                },
                {
                    title: this.$t('submission.abstract_list.table_channel' /* 渠道 */),
                    dataIndex: 'channel_title',
                    align: 'center',
                    width: 100
                },
                {
                    title: this.$t('submission.abstract_list.table_attachment' /* 全文附件 */),
                    dataIndex: 'attachment',
                    align: 'center',
                    scopedSlots: { customRender: 'attachment' }
                    // width: 150
                },
                {
                    title: this.$t('submission.abstract_list.table_ppt' /* PPT */),
                    align: 'center',
                    dataIndex: 'updatePPT',
                    scopedSlots: { customRender: 'updatePPT' }
                    // width: 280
                },
                {
                    title: this.$t('submission.abstract_list.table_poster' /* 电子壁报 */),
                    align: 'center',
                    dataIndex: 'ppt',
                    scopedSlots: { customRender: 'poster' }
                    // width: 150
                },
                {
                    title: this.$t('submission.abstract_list.table_notice' /* 论文录取通知函 */),
                    align: 'center',
                    dataIndex: 'notice',
                    scopedSlots: { customRender: 'notice' },
                    width: 150
                },
                // {
                //     title: '备注',
                //     align: 'center',
                //     dataIndex: 'remark',
                //     scopedSlots: { customRender: 'remark' },
                //     width: 150
                // },
                {
                    title: this.$t('submission.abstract_list.table_last_update_time' /* 最后更新时间 */),
                    align: 'center',
                    width: 150,
                    customRender: (text, record) => {
                        return moment(record.update_time * 1000).format('YYYY-MM-DD hh:mm:ss');
                    }
                },
                {
                    title: this.$t('submission.abstract_list.table_action' /* 操作 */),
                    dataIndex: 'action',
                    align: 'center',
                    scopedSlots: { customRender: 'action' },
                    fixed: 'right',
                    width: 300
                }
            ],
            dataSource: [],
            searchParams: {
                // reg_no: '', // 注册号
                number: '', // 论文id
                title: '', //  题目
                real_name: '', // 第一作者
                org_cnname: '', // 第一作者单位
                t_real_name: '', // 投稿作者
                first_author_province: 0, // 第一作者省份
                is_reg_fee: 0, // 支付状态
                is_finish: 0, // 稿件状态
                is_finalization: 0, // 审核状态
                channel_id: 0, // 论文通道
                class_id: 0, // 论文类别
                review_results: 0, // 录用类型
                abstract_sort: 0, // 排序
                publish_type: '' // 拟交流类型
                // acceptance_state: 0 // 是否接受
            },
            selectedRowKeys: [], // 选中的行
            loadData: parameter => {
                let params = {
                    ...parameter,
                    ...this.searchParams
                };
                console.log(JSON.stringify(params));
                return this.$request.post({ url: 'getAbstractList', data: params }).then(res => {
                    const { List, PageInfo } = res.data;
                    return {
                        data: List,
                        pageSize: PageInfo.limit,
                        totalCount: PageInfo.count,
                        totalPage: PageInfo.max_page,
                        pageNo: PageInfo.page
                    };
                });
            },
            channelList: [], // 通道列表
            classList: [], // 论文类别列表
            hireList: [], // 录用类型列表
            publishTypeObj: {}, // 拟交流类型
            provinceList: [], // 省份列表
            baseConfig: {} // 基础参数配置
        };
    },
    mounted() {},
    methods: {
        handleClearSearchValueEvent() {
            this.searchParams = {
                // reg_no: '', // 注册号
                number: '', // 论文id
                title: '', //  题目
                real_name: '', // 第一作者
                org_cnname: '', // 第一作者单位
                t_real_name: '', // 投稿作者
                first_author_province: 0, // 第一作者省份
                is_reg_fee: 0, // 支付状态
                is_finish: 0, // 稿件状态
                is_finalization: 0, // 审核状态
                class_id: 0, // 论文类别
                review_results: 0, // 录用类型
                abstract_sort: 0, // 排序
                publish_type: '' // 拟交流类型
            };
            this.$refs.table.loadData();
        },
        isAuditFun(item) {
            const { is_open_review_results, reviews_results_type } = this.baseConfig;
            if (is_open_review_results == 1) {
                if (reviews_results_type) {
                    const reviews_results_typeArr = reviews_results_type.split(',');
                    if (reviews_results_typeArr.indexOf(`${item.review_results}`) != -1) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        // 获取全局配置
        getSubmissionInfo() {
            this.$request.post({ url: 'getSubmissionInfo' }).then(res => {
                console.log(res.data);
                this.baseConfig = res.data;
                console.log(this.baseConfig);
            });
        },
        // 通道列表
        getSubmissionChannelList() {
            this.$request.post({ url: 'getSubmissionChannelList', data: { page: 1, limit: 9999 } }).then(res => {
                let { list } = res.data;
                this.channelList = list;
            });
        },
        // 论文类别列表
        getAbstractClass() {
            this.$request.post({ url: 'getAbstractClass', data: { channel_id: 0 } }).then(res => {
                let classList = [];
                this.diffTreeFormatData(res.data, classList);
                this.classList = classList;
                this.classList.push({
                    children: [],
                    disabled: false,
                    key: 0,
                    title: this.$t('submission.abstract_list.search_class_placeholder' /* 请选择论文类别 */),
                    value: 0
                });
            });
        },
        // 获取录用类型列表
        getHireList() {
            this.$request.post({ url: 'getHireList' }).then(res => {
                const { data } = res;
                this.hireList = data;
            });
        },
        // 获取拟交流类型列表
        getFormOptions() {
            this.$request.post({ url: 'getFormOptions', data: { field_code: 'publish_type' } }).then(res => {
                this.publishTypeObj = res.data;
            });
        },
        // 递归格式化数据
        diffTreeFormatData(data, newList) {
            let { lang } = this.$route.params;
            data.forEach(item => {
                let newItem = {
                    key: item.class_id,
                    value: item.class_id,
                    title: item.name[lang],
                    disabled: false,
                    children: []
                };
                if (item.items?.length) {
                    newItem.disabled = true;
                    this.diffTreeFormatData(item.items, newItem.children);
                }
                newList.push(newItem);
            });
        },
        resetList() {
            this.$refs.table.loadData();
        },
        handleSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
        },
        handleEditEvent(record) {
            this.$refs.abstractEditRef.show(record.id);
        },
        handleDeleteEvent(record) {
            let { id } = record;
            this.$confirm({
                title: this.$t('submission.abstract_list.delete_confirm_title' /*  */),
                content: this.$t('submission.abstract_list.delete_confirm_content' /* 是否要删除该稿件 */),
                onOk: () => {
                    this.$request.post({ url: 'deleteAbstractListItem', data: { id } }).then(() => {
                        this.$message.success(this.$t('submission.abstract_list.delete_success' /* 删除成功 */));
                        this.resetList();
                    });
                }
            });
        },
        // 下载附件
        handleDownloadAnnexEvent(item) {
            let link = document.createElement('a');
            if (item && (item.abstract_annex || item.abstract_annex_en)) {
                if (item.abstract_annex) {
                    link.href = 'https://files.sciconf.cn/' + item.abstract_annex;
                } else {
                    link.href = 'https://files.sciconf.cn/' + item.abstract_annex_en;
                }
                link.target = '_blank';
                link.click();
            } else {
                this.$message.info(this.$t('submission.abstract_list.attachment_not_exist' /* 附件不存在 */));
            }
        },
        // 获取省份列表
        getProvinceList() {
            this.$store.dispatch('getAddress').then(res => {
                this.provinceList = res[42]?.list;
            });
        }
    },
    created() {
        this.getSubmissionInfo();
    },
    mounted() {
        this.getSubmissionChannelList();
        this.getAbstractClass();
        this.getHireList();
        this.getFormOptions();
        this.getProvinceList();
    }
};
</script>
<style scoped lang="less">
@media screen and (max-width: 768px) {
    .button-list {
        display: block;
        ::v-deep(.ant-btn) {
            margin-left: 0;
            margin-right: 0;
            margin-bottom: 10px;
        }
    }
}
</style>
